module.exports = __webpack_public_path__ + "dlssrvtline2/img/vi-slider-1.jpg?8755f26d";